import request from '@/api/request';
const mallWeb = '/lego-tool-web/lego';
const accountWeb = '/account-web';
const redeemWeb = '/redeem-code-web';
const bizWeb = '/ylk-biz';
const yooplayWeb = '/yooplay-account-web';
const matchWebPrefix = '/app-match-web';
const vipBasicPrefix = '/vip-basic';

const apis = {
  legoActivityInfo: `/activity/legoActivityInfo`,
  legoActivityPreviewInfo: `/activity/legoActivityPreviewInfo`,
  bindCoupons: `/activity/getTheDiscountTicket`,
  wyIdConfig: `/token-exchange/wechat`,
  jsSDKConfig: `/apps/yvipRestApi/public/wechatJsApiConfig.do`,
  exchange: `/redeem/exchange`,
  yuCardGoBuy: `/api/card/buy`,
  checkStock: `/api/card/checkStock`,
  payTypes: `/api/card/paytypes`,
};

// 活动详情
const getPageInfo = (data) => {
  return request({
    url: `${mallWeb}${apis.legoActivityInfo}`,
    method: 'POST',
    data,
    isMock: false,
  });
};

// 预览活动详情
const getPreViewInfo = (data) => {
  return request({
    url: `${mallWeb}${apis.legoActivityPreviewInfo}`,
    method: 'POST',
    data,
  });
};

// 绑定优惠券
const bindCoupons = (data) => {
  return request({
    url: `${mallWeb}${apis.bindCoupons}`,
    method: 'POST',
    data,
  });
};

const yooplayBindCoupons = (data) => {
  return request({
    url: `/yooplay-activity-web/api/activity/getTheDiscountTicket`,
    method: 'POST',
    data,
  });
};
// 集成sdk config配置
const registerSdk = (params) => {
  return request({
    url: `${apis.jsSDKConfig}`,
    method: 'GET',
    params,
  });
};

// 获取网鱼id
const getWyId = (params) => {
  return request({
    url: `${accountWeb}${apis.wyIdConfig}`,
    method: 'GET',
    params,
  });
};

// 兑换优惠券
const exchangeCoupons = (data) => {
  return request({
    url: `${redeemWeb}${apis.exchange}`,
    method: 'POST',
    data,
  });
};
//  购买会员卡前校验库存
const checkMembershipStock = (params) => {
  return request({
    url: `${bizWeb}${apis.checkStock}`,
    method: 'GET',
    params,
  });
};
// 购买会员卡(会员卡积分组件点击购买)
const cardGoBug = (data) => {
  return request({
    url: `${bizWeb}${apis.yuCardGoBuy}`,
    method: 'POST',
    data,
  });
};
//  支付方式列表
const getPayTypesList = (params) => {
  return request({
    url: `${bizWeb}${apis.payTypes}`,
    method: 'GET',
    params,
  });
};

//  投票
const userVote = (data) => {
  return request({
    url: `${yooplayWeb}/manager/vote/userVote`,
    method: 'POST',
    data,
  });
};

//  根据id获取投票配置详情
const geSubById = (params) => {
  return request({
    url: `${yooplayWeb}/manager/vote/geSubById`,
    method: 'GET',
    params,
  });
};

//  根据id获取投票配置详情
const getSubByIdWyuid = (params) => {
  return request({
    url: `${yooplayWeb}/manager/vote/getSubByIdWyuid`,
    method: 'POST',
    data: params,
  });
};

//  根据wyuid判断用户是否授权
const userHasAuth = (params) => {
  return request({
    url: `${yooplayWeb}/manager/matchUser/userHasAuth`,
    method: 'GET',
    params,
  });
};

//  根据wyuid自动授权
const autoAuthMatchUser = (params) => {
  return request({
    url: `${yooplayWeb}/manager/matchUser/autoAuthMatchUser`,
    method: 'GET',
    params,
  });
};

//  获取二维码
const getGenerateQrCode = () => {
  return request({
    url: `${yooplayWeb}/yooplay/qrCode/generateQrCode`,
    method: 'POST',
    data: {},
  });
};

//  获取二维码
const getGenerateQrToken = (params) => {
  return request({
    url: `${yooplayWeb}/api/qrCode/generateQrToken`,
    method: 'POST',
    data: params,
  });
};

//  获取绑定鉴权
const getExtPlatDataAction = (params) => {
  return request({
    url: `/yooplay-match-web/yooplay/tencent/getExtPlatData`,
    method: 'POST',
    data: params,
  });
};

const tencentGetPrizeAction = (params) => {
  return request({
    url: `/yooplay-match-web/lego/tencent/receivePrize`,
    method: 'POST',
    data: params,
  });
};

const legoReceiveBindTaskPrize = (params) => {
  return request({
    url: `/yooplay-match-web/yooplay/bindTask/legoReceiveBindTaskPrize`,
    method: 'POST',
    data: params,
  });
};

const legoBindTaskReward = (params) => {
  return request({
    url: `${matchWebPrefix}/yooplay/game/legoBindTaskReward`,
    method: 'POST',
    data: params,
  });
};

const tencentGetBindUser = (params) => {
  return request({
    url: `/yooplay-match-web/lego/tencent/getBindUser`,
    method: 'POST',
    data: params,
  });
};

const getPubgAccount = (params) => {
  return request({
    url: `${yooplayWeb}/yooplay/pubg/getPubgAccount`,
    method: 'GET',
    params,
  });
};

const bindUser = (params) => {
  return request({
    url: `${yooplayWeb}/yooplay/pubg/bindUser`,
    method: 'POST',
    data: params,
  });
};

const submitLegoForm = (params) => {
  return request({
    url: `${mallWeb}/activity/submitLegoForm`,
    method: 'POST',
    data: params,
  });
};

const getQuestions = (params) => {
  return request({
    url: `${yooplayWeb}/yooplay/task/getQuestions`,
    method: 'POST',
    data: params,
  });
};

const authUser = (params) => {
  return request({
    url: `${yooplayWeb}/yooplay/task/authUser`,
    method: 'POST',
    data: params,
  });
};

const rewardTask = (params) => {
  return request({
    url: `${yooplayWeb}/yooplay/task/reward`,
    method: 'POST',
    data: params,
  });
};

const rewardMechaTask = (params) => {
  return request({
    url: `/yooplay-match-web/yooplay/task/reward`,
    method: 'POST',
    data: params,
  });
};
const pullSingleData = (params) => {
  return request({
    url: `${yooplayWeb}/yooplay/task/pullSingleDataLego`,
    method: 'GET',
    params,
  });
};

const pullMechaData = (params) => {
  return request({
    url: `${yooplayWeb}/yooplay/task/pullSingleMechaDataLego`,
    method: 'GET',
    params,
  });
};

const lotteryReward = (data) => {
  return request({
    url: `${yooplayWeb}/lego/score/lottery/reward`,
    method: 'POST',
    data,
  });
};

const lotteryAppReward = (data) => {
  return request({
    url: `/vip-activity-web/frondEnd/lottery/legoReward`,
    method: 'POST',
    data,
  });
};

const gameReward = (data) => {
  return request({
    url: `${matchWebPrefix}/yooplay/game/reward`,
    method: 'POST',
    data,
  });
};

const getRankPrize = (params) => {
  return request({
    url: `/yooplay-match-web/api/yooplay/tencent/getRankPrize`,
    method: 'POST',
    data: params,
  });
};

const appGetRankPrize = (params) => {
  return request({
    url: `${matchWebPrefix}/api/lego/game/getRankPrize`,
    method: 'POST',
    data: params,
  });
};

const yooplayReward = (params) => {
  return request({
    url: `/yooplay-activity-web/api/activity/reward`,
    method: 'POST',
    data: params,
  });
};

export {
  getPageInfo,
  bindCoupons,
  getWyId,
  registerSdk,
  exchangeCoupons,
  getPreViewInfo,
  cardGoBug,
  checkMembershipStock,
  getPayTypesList,
  userVote,
  geSubById,
  userHasAuth,
  autoAuthMatchUser,
  getGenerateQrCode,
  getGenerateQrToken,
  getExtPlatDataAction,
  tencentGetPrizeAction,
  tencentGetBindUser,
  getPubgAccount,
  bindUser,
  getQuestions,
  authUser,
  rewardTask,
  pullSingleData,
  submitLegoForm,
  getSubByIdWyuid,
  lotteryReward,
  legoReceiveBindTaskPrize,
  pullMechaData,
  rewardMechaTask,
  gameReward,
  legoBindTaskReward,
  getRankPrize,
  appGetRankPrize,
  yooplayReward,
  yooplayBindCoupons,
  lotteryAppReward,
};
